import { render, staticRenderFns } from "./IntegrationList.view.vue?vue&type=template&id=9633f884&"
import script from "./IntegrationList.view.vue?vue&type=script&lang=js&"
export * from "./IntegrationList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports